import React from 'react';
import {
	FormattedMessage,
	defineMessages,
} from 'react-intl';

import CurrentUserProfileContextActions from '~/components/app/CurrentUserProfileContextActions';
import EmailSettingsGroup from '~/components/logic/memberDetail/formGroups/EmailSettingsGroup';
import PersonalSettingsGroup from '~/components/logic/memberDetail/formGroups/PersonalSettingsGroup';
import Sections from '~/components/logic/lego/Sections';
import UserProfile from '~/components/app/UserProfile';

import useCurrentUserId from '~/hooks/useCurrentUserId';
import useUserMemberships from '~/hooks/useUserMemberships';

import matchAndReturn from '~/utilities/matchAndReturn';



enum Section {
	EmailSettings = 'emailSettings',
	PersonalSettings = 'personalSettings',
}

const SectionSorting = [
	Section.PersonalSettings,
	Section.EmailSettings,
];

const messages = defineMessages({
	[Section.EmailSettings]: {
		id: 'ui.members.formGroups.emailSettings',
	},
	[Section.PersonalSettings]: {
		id: 'ui.members.formGroups.personalSettings',
	},
});



type Props = {
	getSectionRoute: (section: Section) => string,
};

const UserProfileContent: React.FC<Props> = (props) => {
	const {
		getSectionRoute,
	} = props;

	const currentUserId = useCurrentUserId();

	const userMemberships = useUserMemberships(currentUserId);

	if (
		currentUserId === null
		|| userMemberships === null
	) {
		return null;
	}

	return (
		<Sections
			actions={(
				<CurrentUserProfileContextActions />
			)}
			getSectionRoute={(section) => getSectionRoute(section)}
			overview={(
				<UserProfile
					userId={currentUserId}
				/>
			)}
			renderSectionContent={(section) => matchAndReturn(section, {
				[Section.EmailSettings]: (
					<EmailSettingsGroup
						isForCurrentUser={true}
						legacyUserId={currentUserId}
					/>
				),
				[Section.PersonalSettings]: (
					<PersonalSettingsGroup
						isForCurrentUser={true}
						memberships={userMemberships}
						userId={currentUserId}
					/>
				),
			})}
			renderSectionTitle={(section) => (
				<FormattedMessage {...messages[section]} />
			)}
			sections={SectionSorting}
		/>
	);
};



export default UserProfileContent;
